// Fields the Modify Patient form actually asks for, so the completion figure
// reflects what is still blank on screen rather than every key on the record.
export const PERSONAL_COMPLETION_FIELDS = [
  'firstName',
  'middleName',
  'surname',
  'email',
  'mobile',
  'country',
  'state',
  'city',
  'area',
  'location',
  'pincode',
  'education',
  'profession',
  'industry',
  'reference',
  'motherTongue',
  'religion',
  'gender',
  'dateOfBirth',
  'maritalStatus',
  'anniversary',
  'profile_image',
];

// Only rendered once the patient exists, so it only counts for saved records.
export const MEDICAL_COMPLETION_FIELDS = ['bloodGroup', 'weight', 'height'];

export const isFieldFilled = (value) => {
  if (value === null || value === undefined) return false;
  if (Array.isArray(value)) return value.length > 0;
  if (typeof value === 'object') return Object.keys(value).length > 0;
  return String(value).trim() !== '';
};

export const getProfileCompletion = (formData) => {
  const fields = formData?._id ? [...PERSONAL_COMPLETION_FIELDS, ...MEDICAL_COMPLETION_FIELDS] : PERSONAL_COMPLETION_FIELDS;

  const filled = fields.filter((field) => isFieldFilled(formData?.[field]));
  const missing = fields.filter((field) => !isFieldFilled(formData?.[field]));

  return {
    percent: fields.length ? Math.round((filled.length / fields.length) * 100) : 0,
    filled: filled.length,
    total: fields.length,
    missing,
  };
};

// Human labels for the "still missing" hint under the bar.
export const COMPLETION_FIELD_LABELS = {
  firstName: 'First Name',
  middleName: 'Middle Name',
  surname: 'Last Name',
  email: 'Email',
  mobile: 'Contact Number',
  country: 'Country',
  state: 'State',
  city: 'City',
  area: 'Area',
  location: 'Address',
  pincode: 'Pincode',
  education: 'Education',
  profession: 'Profession',
  industry: 'Industry',
  reference: 'Reference',
  motherTongue: 'Mother Tongue',
  religion: 'Religion',
  gender: 'Gender',
  dateOfBirth: 'Date of Birth',
  maritalStatus: 'Marital Status',
  anniversary: 'Anniversary',
  profile_image: 'Profile Image',
  bloodGroup: 'Blood Group',
  weight: 'Weight',
  height: 'Height',
};

// Age buckets used wherever the record has no explicit Age Group stored.
export const deriveAgeGroup = (dateOfBirth) => {
  if (!dateOfBirth) return '';
  const birth = new Date(dateOfBirth);
  if (isNaN(birth.getTime())) return '';
  const age = Math.abs(new Date(Date.now() - birth.getTime()).getUTCFullYear() - 1970);
  if (age <= 12) return '0-12 (Child)';
  if (age <= 19) return '13-19 (Teen)';
  if (age <= 35) return '20-35';
  if (age <= 50) return '36-50';
  if (age <= 65) return '51-65';
  return '65+';
};
